import MyUHLUsersContainer from "../containers/MyUHLUsersContainer";

const MyUHLUsersPage = () => {
    return <MyUHLUsersContainer />;
};

export default MyUHLUsersPage;
